'use strict';

const Mn = require('backbone.marionette');
const CoverTemplate = require('balus/ui/template/body/data-content/title.hbs');

module.exports = Mn.View.extend({
    template: CoverTemplate,
    modelEvents: {
        'change': 'render'
    },
    templateContext: function() {
        const latestVersion = this.model.getLatestVersion();
        const contentType = latestVersion.getMetaData().getContentType();

        return {
            latestVersion: latestVersion.toJSON(),
            contentType: contentType
        };
    }
});


// WEBPACK FOOTER //
// ./balus/ui/view/body/data-content/title.js